const validate = (values) => {
  const errors = {};
  if (!values.contractType) {
    errors.contractType = 'Esse campo não pode ficar vazio';
  }
  if (!values.student) {
    errors.student = 'Esse campo não pode ficar vazio';
  }
  if (!values.responsible1) {
    errors.responsible1 = 'Esse campo não pode ficar vazio';
  } else {
    const { responsible } = values.responsible1;
    if (!responsible.cpf) {
      errors.responsible1 = 'O Responsável deve ter um CPF válido';
    } else if (!responsible.zipCode) {
      errors.responsible1 = 'O Responsável deve possuir um CEP válido';
    } else if (!responsible.addressNumber) {
      errors.responsible1 =
        'O número do endereço do responvável deve ser informado';
    }
  }
  if (!values.numberContract) {
    errors.numberContract = 'Esse campo não pode ficar vazio';
  }
  if (!values.validity) {
    errors.validity = 'Esse campo não pode ficar vazio';
  }
  if (values.validity) {
    const regex = /\D/g;
    if (regex.test(values.validity))
      errors.validity = 'Esse campo deve conter números';
  }
  if (values.products && values.products.length === 0) {
    errors.add = 'Favor informar os itens do contrato';
  }
  if (!values.account) {
    errors.account = 'Esse campo não pode ficar vazio';
  }
  return errors;
};

export default validate;
